export const about = {
  "header-de": "Eine Kirche nach dem Herzen Gottes",
  "text-de": "Liebe Gott. Liebe deinen Nächsten. Das sind die Prinzipien, nach denen wir leben. In Gemeinschaft & Liebe wollen wir spirituell wachsen. Das bedeutet morgen ein besserer Mensch zu sein, als wir es gestern waren.",
  "subtitle-de": "AGAPE WIEN",
  "header-ro": "O biserică după inima lui Dumnezeu",
  "text-ro": "Iubește-L pe Dumnezeu. Iubește pe aproapele tău.Acestea sunt principiile după care trăim. În părtășie și iubire vrem să creștem spiritual. Asta înseamnă să fim un om mai bun decât cel care am fost ieri.",
  "subtitle-ro": "AGAPE VIENA",
}


